import { render, staticRenderFns } from "./diygoods.vue?vue&type=template&id=03d81e5e&scoped=true&"
import script from "./diygoods.vue?vue&type=script&lang=js&"
export * from "./diygoods.vue?vue&type=script&lang=js&"
import style0 from "./diygoods.vue?vue&type=style&index=0&id=03d81e5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d81e5e",
  null
  
)

export default component.exports